export const TitleGrey = '#777';
export const TitleBlue = '#034ea2';
export const BorderGrey = '#e7e7e7';
export const BackgroundWhite = '#f8f8f8';
